export const fallbackMenuConfig = [
    {
        id: 'dashboard',
        label: 'Главная',
        route: '/app',
        permissions: ['hyosung.custom_packaging', 'hyosung.custom_logist', 'hyosung.custom_guest'],
    },
    {
        id: 'acceptance',
        label: 'Приемка',
        route: '/app/acceptance',
        permissions: ['hyosung.custom_packaging'],
    },
    {
        id: 'search',
        label: 'Поиск серийных номеров',
        route: '/app/search',
        permissions: ['hyosung.custom_packaging'],
    },
    {
        id: 'assembling',
        label: 'Сборка заявки',
        route: '/app/requests/assemble',
        permissions: ['hyosung.custom_packaging'],
    },
    {
        id: 'module-batches',
        label: 'Отправка МСК / ТМН / ХАБ',
        route: '/app/module-batches',
        permissions: ['hyosung.custom_packaging'],
    },
    {
        id: 'cassettes',
        label: 'Кассеты',
        route: '/app/cassettes',
        permissions: ['hyosung.custom_packaging', 'hyosung.custom_logist', 'hyosung.custom_guest'],
    },
    {
        id: 'reserve',
        label: 'Резерв',
        route: '/app/reserve',
        permissions: ['hyosung.custom_packaging', 'hyosung.custom_logist', 'hyosung.custom_guest'],
    },
    {
        id: 'expectation-act',
        label: 'Ожидание актов',
        route: '/app/acts/waiting',
        permissions: ['hyosung.custom_packaging', 'hyosung.custom_logist', 'hyosung.custom_guest'],
    },
    {
        id: 'delivery-send',
        label: 'Ожидание отправок',
        route: '/app/shipments/waiting',
        permissions: ['hyosung.custom_packaging', 'hyosung.custom_logist', 'hyosung.custom_guest'],
    },
    {
        id: 'engineers',
        label: 'Инженеры',
        route: '/app/engineers',
        permissions: ['hyosung.custom_packaging', 'hyosung.custom_logist', 'hyosung.custom_guest'],
        children: [
            {
                id: 'engineer-statistics',
                label: 'Статистика инженеров',
                route: '/app/engineers/statistics',
            },
            {
                id: 'motivation',
                label: 'Мотивация',
                route: '/app/engineers/motivation',
            },
        ],
    },
];
